import { useEffect, useState } from 'react';
import { useUserSettingsContext } from 'contexts';
import { selectRoomId } from 'state/selectors';
import {
    getPersistedWebinarLocks,
    applyPersistedWebinarMediaLocks,
    type PersistedWebinarLocks,
} from './webinarPrejoinLocks';

/**
 * На prejoin:
 * - всегда гасит cam/mic prefs, если есть session-локи вебинара (чтобы rejoin не публиковал ON);
 * - дизейблит кнопки только после F5 (lockPrejoinUi), не после явного выхода.
 */
export const useWebinarPrejoinMediaLock = () => {
    const { setAudioEnabled, setVideoEnabled } = useUserSettingsContext();
    const roomId = selectRoomId();
    const [locks, setLocks] = useState<PersistedWebinarLocks | null>(() => getPersistedWebinarLocks(roomId));

    useEffect(() => {
        const persisted = applyPersistedWebinarMediaLocks(setAudioEnabled, setVideoEnabled, roomId);
        setLocks(persisted);
    }, [roomId, setAudioEnabled, setVideoEnabled]);

    const lockUi = Boolean(locks?.lockPrejoinUi);

    return {
        isMicLocked: lockUi && Boolean(locks?.microDisabled),
        isCamLocked: lockUi && Boolean(locks?.cameraDisabled),
    };
};
